<template>
  <div id="app">
    <pulse-loader :loading="loading" :color="'#843CAE'" :size="'24px'"></pulse-loader>
    <toast position="s"></toast>
    <v-dialog />
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Toast } from 'vuex-toast';

import PulseLoader from '@/components/Loader';

export default {
  name: 'app',
  methods: {
    ...mapActions([
      'logout',
    ]),
  },
  computed: {
    ...mapState({
      loading: state => state.loader.loading,
    }),
  },
  components: {
    PulseLoader,
    Toast,
  },
};
</script>
<style lang="sass">
  @import url("https://fonts.googleapis.com/css?family=Roboto:400,500,700")
</style>
<style>

@font-face {
  font-family: 'icomoon';
  src:  url('/static/fonts/icomoon.eot?32ayps');
  src:  url('/static/fonts/icomoon.eot?32ayps#iefix') format('embedded-opentype'),
    url('/static/fonts/icomoon.ttf?32ayps') format('truetype'),
    url('/static/fonts/icomoon.woff?32ayps') format('woff'),
    url('/static/fonts/icomoon.svg?32ayps#icomoon') format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="otto-icon-"], [class*=" otto-icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.otto-icon-notification:before {
  content: "\e902";
  color: #843cae;
}
.otto-icon-next:before, .fc-icon-otto-icon-next:before {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e900";
  color: #843cae;
}
.otto-icon-prev:before, .fc-icon-otto-icon-prev:before {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e901";
  color: #843cae;
}
.otto-icon-settings:before {
  content: "\e915";
  color: #843cae;
}
.otto-icon-cal:before {
  content: "\e916";
}


</style>
<style lang="sass" src="./assets/styles/app.sass"></style>



// WEBPACK FOOTER //
// src/App.vue